export default {
  // Header
  home: 'الرئيسية',
  about: 'من نحن',
  services: 'خدماتنا',
  portfolio: 'سابقة الأعمال',
  blog: 'المدونة',
  contact: 'تواصل معنا',
  login: 'تسجيل الدخول',
  guestMode: 'الدخول كزائر',
  myAccount: 'حسابي',
  
  // Hero Section
  heroTitle: 'الأستاذ مصطفى محمد',
  heroSubtitle: 'خبرة متميزة في تقديم الحلول المؤسسية الاحترافية',
  heroDescription: 'نقدم لكم أفضل الخدمات المتخصصة بجودة عالية واحترافية تامة، مع فريق عمل متمرس يضمن لكم تحقيق أهدافكم بكفاءة ودقة متناهية',
  requestService: 'اطلب خدمة',
  learnMore: 'اعرف المزيد',
  
  // About Section
  aboutTitle: 'نبذة عن المؤسسة',
  aboutDescription: 'مؤسسة رائدة في تقديم الخدمات المتخصصة بأعلى معايير الجودة والاحترافية. نفخر بخبرتنا الطويلة وسجلنا الحافل في خدمة عملائنا وتحقيق تطلعاتهم بكل كفاءة وإتقان.',
  yearsExperience: 'سنوات من الخبرة',
  completedProjects: 'مشروع منجز',
  satisfiedClients: 'عميل راضٍ',
  
  // Services Section
  servicesTitle: 'خدماتنا المتميزة',
  servicesSubtitle: 'نقدم مجموعة شاملة من الخدمات الاحترافية التي تلبي احتياجاتكم',
  viewDetails: 'عرض التفاصيل',
  
  // Features Section
  featuresTitle: 'لماذا تختارنا',
  featuresSubtitle: 'نتميز بمجموعة من المزايا التي تجعلنا الخيار الأمثل لك',
  feature1Title: 'جودة عالية',
  feature1Desc: 'نلتزم بأعلى معايير الجودة في جميع خدماتنا',
  feature2Title: 'فريق محترف',
  feature2Desc: 'فريق عمل متخصص وذو خبرة طويلة في المجال',
  feature3Title: 'أسعار تنافسية',
  feature3Desc: 'نقدم أفضل الأسعار مع الحفاظ على الجودة',
  feature4Title: 'دعم مستمر',
  feature4Desc: 'نوفر دعماً فنياً متواصلاً لعملائنا',
  
  // Testimonials
  testimonialsTitle: 'آراء عملائنا',
  testimonialsSubtitle: 'ثقة عملائنا هي أكبر إنجازاتنا',
  
  // Contact Section
  contactTitle: 'تواصل معنا',
  contactSubtitle: 'نسعد بالرد على استفساراتكم وخدمتكم',
  yourName: 'الاسم الكامل',
  yourEmail: 'البريد الإلكتروني',
  yourPhone: 'رقم الهاتف',
  yourMessage: 'رسالتك',
  sendMessage: 'إرسال الرسالة',
  
  // Footer
  footerAbout: 'مؤسسة متخصصة في تقديم الحلول المؤسسية الاحترافية بأعلى معايير الجودة',
  quickLinks: 'روابط سريعة',
  followUs: 'تابعنا',
  allRightsReserved: 'جميع الحقوق محفوظة',
  
  // Vision & Mission
  ourVision: 'رؤيتنا',
  visionText: 'أن نكون الخيار الأول والأمثل في تقديم الخدمات المتخصصة على مستوى المنطقة',
  ourMission: 'رسالتنا',
  missionText: 'تقديم خدمات متميزة بجودة عالية تلبي تطلعات عملائنا وتحقق رضاهم التام',
  ourValues: 'قيمنا',
  value1: 'الاحترافية',
  value2: 'الجودة',
  value3: 'الأمانة',
  value4: 'الالتزام',
  
  // Services List
  service1: 'الاستشارات المؤسسية',
  service2: 'التخطيط الاستراتيجي',
  service3: 'إدارة المشاريع',
  service4: 'التطوير المؤسسي',
  service5: 'التدريب والتأهيل',
  service6: 'الدراسات والأبحاث',
  
  // Request Service
  requestServiceTitle: 'طلب خدمة',
  selectService: 'اختر الخدمة',
  serviceDetails: 'تفاصيل الطلب',
  attachFiles: 'إرفاق ملفات',
  submitRequest: 'إرسال الطلب',
  
  // My Account
  myProfile: 'ملفي الشخصي',
  myRequests: 'طلباتي',
  notifications: 'الإشعارات',
  editProfile: 'تعديل البيانات',
  logout: 'تسجيل الخروج',
  
  // Blog
  readMore: 'اقرأ المزيد',
  latestNews: 'آخر الأخبار',
  
  // Common
  loading: 'جاري التحميل...',
  success: 'تم بنجاح',
  error: 'حدث خطأ',
  close: 'إغلاق',
};